import React, { useState, useEffect } from 'react'
import { FormControl } from 'react-bootstrap'
import DateRangePicker from 'react-bootstrap-daterangepicker'
import { FetchB2COrderState, FetchB2COrderProcessingState } from '../../fetcher.js'
import { DateSelect, StateSelect, useDateFilter, useFilterReport, useSearchFilter, useSelectFilter } from '../../utils/filterutils'
import { useExpandRows, useSortSalesReport } from '../../utils/tablehooks'
import { B2COrdersReportHeaderView, B2COrdersReportTableView } from './B2COrdersReportView'
import moment from 'moment'

const B2COrdersReportTableContainer = ({ b2COrdersReport, options, loadReport, setOrderToView, handleShowOrder }) => {


    const [b2cOrderStates, setbB2COrderStates] = useState([])
    const [b2cOrderProcessingStates, setB2COrderProcessingStates] = useState([])

    console.log("FetchB2COrderState", b2cOrderStates, b2cOrderProcessingStates)

    const [filterBar, setFilterBar] = useState(false)
    const [filteredReports, setFilteredReports] = useState([])
    const [sortedReports, setSortedReports] = useState([])

    const { expandRow, getIsExpandedRow } = useExpandRows()
    const { sortSalesReport } = useSortSalesReport(b2COrdersReport, setSortedReports)
    const { filterReportBySearchInput, filterReportByDateInput, filterReportBySelectInput } = useFilterReport()
    const { dateSelect, handleDatePickerCallback, handleClearFilter } = useDateFilter()
    const [statusSelect, handleStatusSelectChange] = useSelectFilter()
    const { searchInput, handleSearchInput } = useSearchFilter()

    const defaultFilterOrderState = "-Bestellstatus filtern-"
    const defaultFilterOrderProcessingState = "-Bearbeitungsstatus filtern-"


    const [filterOrderState, setFilterOrderState] = useState(defaultFilterOrderState)
    const [filterOrderProcessingState, setFilterOrderProcessingState] = useState(defaultFilterOrderProcessingState)

    useEffect(() => {
        console.log("useEffect b2COrdersReport", b2COrdersReport)
        let reportCopy = [...b2COrdersReport];
        reportCopy.sort((a, b) => (moment(moment(b['SalesDate'], "DD.MM.YYYY").format("YYYYMMDD"))) - (moment(moment(a['SalesDate'], "DD.MM.YYYY").format("YYYYMMDD"))))
        setFilteredReports(prev => prev = [...reportCopy])
        setSortedReports(prev => prev = [...reportCopy])
        console.log("useEffect setFilteredReports setSortedReports", filteredReports, sortedReports, b2COrdersReport)

    }, [b2COrdersReport])

    useEffect(() => {
        FetchB2COrderProcessingState(setB2COrderProcessingStates)
        FetchB2COrderState(setbB2COrderStates)
    }, [])

    const handleFilterInput = (e) => {
        e.preventDefault()
        e.target.value = e.target.value.toString().toLowerCase().trim(" ")
        //let d;

        //if (adjustedInput != "")
        //    d = [...b2COrdersReport].filter(x => Object.keys(x).some(y => x[y].toString().toLowerCase().includes(adjustedInput)))
        //else
        //    d = b2COrdersReport

        //console.log("handle input", adjustedInput)
        handleSearchInput(e)
    }

    const handleOrderStateFilter = (e) => {
        e.preventDefault()
        const orderState = e.target.value
        console.log("handleOrderStateFilter ", orderState, e.target.value, e.target)
        setFilterOrderState(orderState)
    }

    const handleOrderProcessingStateFilter = (e) => {
        e.preventDefault()
        const orderProcessingState = e.target.value
        setFilterOrderProcessingState(orderProcessingState)
    }
    //const handleOrderStateFilter = (e) => {
    //    e.preventDefault()
    //    const orderState = e.target.value
    //    setFilterOrderState(prev => prev = orderState)

    //    const filteredTransactionsCopy = filterTransactions(searchInput, dateSelect, paymentSelect, orderState, filterOrderProcessingState)
    //    setFilteredTransactions(filteredTransactionsCopy)
    //}
    //const takeSortedReport = () => {
    //    //Maybe this shouldn't be done in general, as there should be another option to deep clone an object!
    //    let deepCopy = JSON.parse(JSON.stringify(sortedReports))
    //    return deepCopy
    //}

    useEffect(() => {
        let filteredReport = filterReportBySearchInput([...sortedReports], searchInput)
        console.log("Filtering", searchInput, dateSelect, statusSelect, sortedReports, filterOrderState, filterOrderProcessingState)
        filteredReport = filterReportByDateInput(filteredReport, dateSelect, "SalesDate")
        filteredReport = filterReportBySelectInput(filteredReport, statusSelect)
        filteredReport = filterReportBySelectInput(filteredReport, filterOrderState !== defaultFilterOrderState && filterOrderState != "default" ? filterOrderState : "", "OrderState")
        filteredReport = filterReportBySelectInput(filteredReport, filterOrderProcessingState !== defaultFilterOrderProcessingState && filterOrderProcessingState !== "default" ? filterOrderProcessingState : "" , "OrderProcessingState")

        setFilteredReports(filteredReport)
    }, [searchInput, dateSelect, statusSelect, sortedReports, filterOrderState, filterOrderProcessingState])

    /**
     * Toggles the filterable value; indicates if filter menu is opened
    */
    //const setFilterbar = () => {
    //    setFilterable(!filterable)
    //}

    const handleSortReport = (e, field) => {
        e.preventDefault()
        console.log("B2COrdersReportTableContainer handleSortReport", e, field)
        sortSalesReport(field)
    }

    const DateSelect = () => {
        const startDate = Date.now
        const endDate = Date.now
        const showCustomRangeLabel = false

        const handleApply = (event, picker) => {
            picker.element.val(
                picker.startDate.format('DD.MM.YYYY') +
                ' - ' +
                picker.endDate.format('DD.MM.YYYY')
            )
        }
        const handleCancel = (event, picker) => {
            picker.element.val('')
            handleClearFilter()
        }

        return (
            <DateRangePicker initialSettings={{
                showCustomRangeLabel,
                startDate, endDate,
                locale: {
                    cancelLabel: 'Zurücksetzen',
                    applyLabel: 'Ok'
                },
                autoUpdateInput: false,

                //ranges: {
                //    'Letzte 7 Tage': [
                //        moment().subtract(6, 'days').toDate(),
                //        moment().toDate(),
                //    ],
                //    'Letzte 30 Tage': [
                //        moment().subtract(29, 'days').toDate(),
                //        moment().toDate(),
                //    ],
                //    'Dieser Monat': [
                //        moment().startOf('month').toDate(),
                //        moment().endOf('month').toDate(),
                //    ],
                //    //'Bis heute': [
                //    //    null,
                //    //    moment().toDate(),
                //    //],
                //},
            }} onApply={handleApply} onCancel={handleCancel}
                onCallback={handleDatePickerCallback} isClearable={false}>
                <FormControl className="dateFilterForm" size="sm" />
            </DateRangePicker>
        );
    }

    return (
        <>
            {/*<SalesReportHeaderView filteredReports={filteredReports} handleSearchInput={handleSearchInput} setFilterbar={setFilterbar} loadReport={loadReport} options={options} />*/}
            <B2COrdersReportTableView
                filterBar={filterBar}
                setFilterBar={setFilterBar}
                report={b2COrdersReport}
                filteredReport={filteredReports}
                setOrderToView={setOrderToView}
                handleShowOrder={handleShowOrder}
                handleFilterInput={handleFilterInput}
                handleSortReport={handleSortReport}
                handleOrderStateFilter={handleOrderStateFilter}
                handleOrderProcessingStateFilter={handleOrderProcessingStateFilter}
                filterOrderState={filterOrderState}
                filterOrderProcessingState={filterOrderProcessingState}
                orderStatesToFilter={b2cOrderStates}
                orderProcessingStatesToFilter={b2cOrderProcessingStates}
                DateSelect={DateSelect}
                f />
        </>
    )
}

export { B2COrdersReportTableContainer }